/*
 * @Author: your name
 * @Date: 2021-03-24 11:06:07
 * @LastEditTime: 2021-03-31 11:19:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \NewBi\src\http\config.js
 */

// import Cookies from 'js-cookie'
// import Router from '@/router'
import { Message } from 'element-ui';
// import { removeToken, userInfoKey } from '@/utils/auth'
// 设置超时时间
export const timeOut = 15000;

// 公共请求地址
// export const  comBaseUrl = 'https://abc.nuekaikai.com'; // 线上地址
// export const  comBaseUrl = 'http://82.156.154.138:20003'; // 线上模拟地址，本地调试地图使用
// export const  comBaseUrl = 'https://www.pta-cnd.com:8080'; // 线上模拟地址，本地调试地图使用
// export const  comBaseUrl = 'http://81.70.251.55:8080'; // 线上模拟地址，本地调试地图使用
// export const comBaseUrl = 'https://www.pta-cnd.com'; // 线上模拟地址，本地调试地图使用
// export const  comBaseUrl = 'http://localhost:20003'; // 本地部署使用
// export const  comBaseUrl = 'http://172.16.112.200:20003'; // 春建本地
// export const  comBaseUrl = 'http://172.16.117.196:30000'; // 测试笔记本地址
// export const  comBaseUrl = 'http://localhost:30000'; // 本地请求地址

let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  // 直接使用空字符串，因为API调用中已经包含了/api前缀
  baseUrl = '';
} else {
  // 生产环境使用当前域名
  baseUrl = window.location.origin;
}
console.log(window.location.origin)
console.log('baseUrl:', baseUrl)
export const comBaseUrl = baseUrl;

// Http请求状态码异常
const httpRequestOverDue = [404, 405, 502];
// token过期业务状态码
const tokenOverDue = [401, 408, 432, 601, 602, 604];
// 接口请求异常业务状态码
const responseOverDue = [-1, 1, 970, 990, 999];
// 错误信息提示

export const NETWORK_ERROR = '网络错误，请联系管理员!';

export const TIMEOUT_ERROR = '网络超时，请重试!';

export const NOTFOUND_ERROR = '内部错误，请联系管理员!';

export const SERVICE_ERROR = '服务异常，请联系管理员!';
export const backPostMessage = () => {
  setTimeout(() => {
    // 需要回调到老BI的方法进行跳转登录页清除cookie
    window.parent.postMessage({
      type: 'removeToken'
    }, '*');
  }, 1500)
  return
}
// 设置错误信息
export const errorHandle = (res) => {
  // http状态
  const responseStatus = res.status;
  // 业务层状态
  const responseCodeStatus = res.data.code;
  // 业务层错误信息提示
  const responseErrorMessage = (res.data.message || SERVICE_ERROR);
  // + `===>异常接口地址[“${res.config.url || ''}”]`
  // 出现异常登录时（如用户Id错误）则默认跳转到登录页面并清空当前本地信息
  if (responseStatus == 403) {
    // Cookies.set(`${userInfoKey}`, '')
    // 跳转至登录页
    backPostMessage()
    // Router.push({ path: '/login' });
    return;
  }
  // Http状态码异常
  if (httpRequestOverDue.includes(responseStatus)) {
    Message.error(NOTFOUND_ERROR);
    return;
  }
  // 业务异常
  /*
  token服务异常
  401-Token会话失效
  408-账号已经在另一台设备上登录
  432-Token为空

  */
  if (tokenOverDue.includes(responseCodeStatus)) {
    Message.error(messageSplit(responseErrorMessage));
    // 重置Token
    // removeToken();
    // Cookies.set(`${userInfoKey}`, '')
    // Router.push({ path: '/login' });
    return;
  }

  // 请求接口异常
  if (responseOverDue.includes(responseCodeStatus)) {
    // 此处暂做提示处理
    Message.error(messageSplit(responseErrorMessage));
    return;
  }
  // 此处暂做提示处理
  // Message.error(messageSplit(responseErrorMessage));
  // 判断当前页是否有el-message标签，如果没有则执行弹窗操作
  if (document.getElementsByClassName('el-message').length === 0) {
    Message(messageSplit('原数据接口异常，现显示本地缓存数据'));
  }
}

// 错误信息返回【】 前端只显示】之后的内容
const messageSplit = (message) => {
  if (message) {
    if (message.indexOf('】') != -1) {
      message = message.split('】')[1];
    }
  }
  return message;
}

